import { createSelector } from 'reselect'
import sortBy from 'lodash/sortBy'

const getState = state => state.PresentationStore

export const getPresentation = state => getState(state).presentation

export const getFetchingRequest = state => getState(state).fetching

export const getCreateSlideRequest = state => getState(state).createSlideRequest

export const getUpdateSlideRequests = state =>
  getState(state).updateSlideRequests

export const getUploadImageRequests = state =>
  getState(state).uploadImageRequests

export const getDeleteSlideRequests = state =>
  getState(state).deleteSlideRequests

export const getUpdatePropertiesRequest = state =>
  getState(state).updatePropertiesRequest

export const getDuplicateSlideRequest = state =>
  getState(state).duplicateSlideRequest

export const getUpdateSlideRequest = (state, id) =>
  getUpdateSlideRequests(state)[id] || { pending: false, requestError: null }

export const getDeleteSlideRequest = (state, id) =>
  getDeleteSlideRequests(state)[id] || { pending: false, requestError: null }

export const getUploadImageRequest = (state, id) =>
  getUploadImageRequests(state)[id] || { pending: false, requestError: null }

export const getSlides = state => getState(state).slides

export const getSlidesMap = createSelector(
  [getSlides],
  slides => (slides ? slides.entities.slides : {})
)

export const getSlidesResult = createSelector(
  [getSlides],
  slides => (slides ? slides.result : [])
)

export const getSlidesList = createSelector(
  [getSlidesResult, getSlidesMap],
  (result, slidesMap) => result.map(id => slidesMap[id])
)

export const getOrderedSlides = createSelector([getSlidesList], slides =>
  sortBy(slides, 'order')
)

export const getOrderedVisibleSlides = createSelector(
  [getOrderedSlides],
  slides => slides.filter(slide => !slide.hidden)
)

export const getSlide = (state, id) => getSlidesMap(state)[id]
